export const tableActionTypes = {
  SET_FORM_ID_REQUEST: "SET_FORM_ID_REQUEST",
  SET_FORM_ID_SUCCESS: "SET_FORM_ID_SUCCESS",
  SET_FORM_ID_FAILURE: "SET_FORM_ID_FAILURE",

  SET_SELECTED_FORM_DATA_REQUEST: "SET_SELECTED_FORM_DATA_REQUEST",
  SET_SELECTED_FORM_DATA_SUCCESS: "SET_SELECTED_FORM_DATA_SUCCESS",
  SET_SELECTED_FORM_DATA_FAILURE: "SET_SELECTED_FORM_DATA_FAILURE"
};
